import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { distinctUntilChanged, debounceTime, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-customer-lookup-ag-grid-control',
  templateUrl: './customer-lookup-ag-grid-control.component.html',
  styleUrls: ['./customer-lookup-ag-grid-control.component.scss'],
})
export class CustomerLookupAgGridControlComponent
  implements ICellRendererAngularComp, OnInit
{
  selectedItem: any;
  items: any[];
  public value: any;

  public params: any;
  public searchFunc: any;
  public formatterFunc: any;

  public itemTemplate: any;
  itemBusy: boolean = false;

  constructor() {}
  agInit(params) {
    this.params = params;
    this.items = params.items;
  }

  refresh(params: any): boolean {
    return true;
  }

  getValue() {
    return this.selectedItem;
  }

  ngOnInit() {}

  onItemSelect(r) {
    this.selectedItem = r;
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term === ''
          ? this.items
          : this.items.filter(
              (v) =>
                (v.CustomerTypeId == 2
                  ? v.BusinessName
                  : v.FirstName + ' ' + v.LastName
                )
                  .toLowerCase()
                  .indexOf(term.toLowerCase()) > -1
            )
      )
    );
  formatter = (x: {
    BusinessName: string;
    FirstName: string;
    LastName: string;
    CustomerTypeId: number;
  }) =>
    x.CustomerTypeId == 2 ? x.BusinessName : x.FirstName + ' ' + x.LastName;
}
